export interface Game2048Theme {
  readonly id: string;
  readonly images: readonly string[];
  readonly startDate?: string;
}

// Preserve this order for the v1 daily assignment.
export const GAME_2048_THEMES: readonly Game2048Theme[] = [
  { id: 'animals-jobs', images: [
    'octopus-chef',
    'fox-detective',
    'frog-gardener',
    'bear-beekeeper',
    'rabbit-astronaut',
    'owl-librarian',
    'raccoon-mechanic',
    'cat-painter',
    'penguin-conductor',
    'turtle-mail-carrier',
    'mouse-tailor',
    'beaver-architect',
    'hedgehog-florist',
    'dog-firefighter',
    'sloth-photographer',
    'crocodile-dentist'
  ] },
  { id: 'retro-space-expedition', images: [
    'rocket-launchpad',
    'lunar-rover',
    'space-diner',
    'radio-observatory',
    'alien-greenhouse',
    'astronaut-campsite',
    'orbital-fuel-station',
    'robot-repair-shop',
    'flying-saucer',
    'female-alien',
    'asteroid-mining-rig',
    'spaceport-control-tower',
    'alien-monster',
    'cosmic-roadside-motel',
    'interstellar-cargo-ship',
    'alien-ruins'
  ] },
  { id: 'inventors-cabinet', images: [
    'weather-bottle',
    'mechanical-beetle',
    'dream-projector',
    'pocket-planetarium',
    'clockwork-bird',
    'memory-camera',
    'automatic-tea-brewer',
    'gravity-defying-hourglass',
    'lightning-powered-lantern',
    'mechanical-flower',
    'cloud-making-machine',
    'underwater-telescope',
    'musical-lockbox',
    'self-writing-quill',
    'miniature-flying-bicycle',
    'perpetual-motion-machine'
  ] },
  { id: '8-bit-nostalgia', startDate: '2027-09-15', images: [
    'ash',
    'blinky',
    'bomberman',
    'breakout',
    'bub',
    'dig-dug',
    'donkey-kong',
    'frogger',
    'link',
    'mario',
    'pac-man',
    'pikachu',
    'qbert',
    'space-invader-fat',
    'space-invader-med',
    'space-invader-thin'
  ] },
  { id: 'eschers-dreams', startDate: '2027-09-16', images: [
    'penrose-triangle',
    'endless-staircase',
    'impossible-cube',
    'three-pronged-fork',
    'waterfall-loop',
    'gravity-house',
    'inside-out-tower',
    'impossible-arch',
    'ascending-bridge',
    'interlocking-frames',
    'self-containing-room',
    'reversed-balcony',
    'endless-aqueduct',
    'impossible-spiral',
    'folded-chessboard',
    'inverted-ziggurat'
  ] },
  { id: 'suspicious-fruits', startDate: '2026-09-21', images: [
    'banana-bandit',
    'strawberry-shoplifter',
    'orange-escape-artist',
    'apple-safecracker',
    'grape-getaway-gang',
    'pineapple-jewel-thief',
    'watermelon-smuggler',
    'lemon-counterfeiter',
    'cherry-pickpockets',
    'peach-art-thief',
    'pomegranate-terrorist',
    'coconut-jailbreaker',
    'mango-casino-cheat',
    'kiwi-graffiti-artist',
    'blueberry-kidnapper',
    'dragon-fruit-arsonist'
  ] }
];
